import { CircularProgress, LinearProgress, Box, styled, Typography } from "@mui/material";

// STYLED COMPONENT
const StyledLoading = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  "& img": {
    width: "auto",
    height: "25px"
  },
  "& .circleProgress": {
    marginTop: "10px"
  },
  "& .linearProgressWrapper": {
    marginTop: "10px",
    width: "200px", // fixed width (you can make this prop-driven)
    display: "flex",
    justifyContent: "center"
  },
  "& .linearProgress": {
    width: "100%"
  }
});

export default function Loading({
  text = "Techno",
  highlight = "Devs",
  highlightColor = "#1e82c3",
  textVariant = "h6",
  variant = "dots", // circular | linear | dots
  size = 40,
  thickness = 4,
  linearWidth = 200
}) {
  const renderLoader = () => {
    switch (variant) {
      case "linear":
        return (
          <Box className="linearProgressWrapper" sx={{ width: linearWidth }}>
            <LinearProgress className="linearProgress" />
          </Box>
        );
      case "dots":
        return (
          <Box mt={1} display="flex" gap={0.5}>
            <span className="dot" />
            <span className="dot" />
            <span className="dot" />
            <style jsx>{`
              .dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: ${highlightColor};
                animation: bounce 1.2s infinite ease-in-out;
              }
              .dot:nth-child(2) {
                animation-delay: 0.2s;
              }
              .dot:nth-child(3) {
                animation-delay: 0.4s;
              }
              @keyframes bounce {
                0%, 80%, 100% {
                  transform: scale(0);
                }
                40% {
                  transform: scale(1);
                }
              }
            `}</style>
          </Box>
        );
      default:
        return (
          <CircularProgress
            className="circleProgress"
            size={size}
            thickness={thickness}
          />
        );
    }
  };

  return (
    <StyledLoading>
      <Typography variant={textVariant}>
        {text}{" "}
        {highlight && <span style={{ color: highlightColor }}>{highlight}</span>}
      </Typography>
      {renderLoader()}
    </StyledLoading>
  );
}
